const UPDATE_HINTS = 1;
const UPDATE_SEARCH_FIELD = 2;
const SEARCH_HINTS_LOADING = 3;
const SEARCH_REASULTS = 4;
const FOCUS = 5;


export default {
    UPDATE_HINTS,
    UPDATE_SEARCH_FIELD,
    SEARCH_HINTS_LOADING,
    SEARCH_REASULTS,
    FOCUS
};